import toastr from "toastr"

import '../scss/toastr.scss';

toastr.options = {
//	progressBar: true,
	positionClass: 'toast-bottom-left'
};

window.toastr = toastr;